import React, { useLayoutEffect, useRef, useCallback, useContext } from 'react';
import iconSvgName from 'apps/journey/util/icon-svg-name';
import ProgressCircle from 'library/components/progress-circle';
import Icons from 'apps/journey/icons/icons';
import * as StyledAllGoals from 'apps/journey/pages/my-journey2/goals/styled-goal';
import { lighten, darken } from 'library/util/css';
import ActiveGoal from 'apps/journey/pages/my-journey2/context/active-goal';
import { styleIcon } from 'apps/journey/pages/my-journey2/components/styled-icon';
import { object, shape, string, array, bool } from 'prop-types';
import KeyCodes from 'library/helpers/key-codes';
import { NoStyleButton } from 'library/components/button';

const Goal = ({ outcome, goal, isVisible }) => {
  const { activeGoalId, setActiveGoalId } = useContext(ActiveGoal);

  const iconExistsCallback = useCallback(
    () => goal.icon != null && !isNaN(parseInt(goal.icon.id)),
    [goal.icon?.id]
  );

  const renderGoalIcon = () => {
    let IconComponent = null;
    if (iconExistsCallback()) {
      IconComponent = Icons[iconSvgName(goal.icon)];
    }

    let StyledIconComponent = IconComponent
      ? styleIcon(IconComponent, outcome.color)
      : null;

    return StyledIconComponent ? (
      <StyledIconComponent className="goalIcon" />
    ) : null;
  };

  const showGoal = useCallback(
    (activeGoalId, setActiveGoalId) => {
      activeGoalId === goal.id
        ? setActiveGoalId(null)
        : setActiveGoalId(goal.id);
    },
    [activeGoalId]
  );

  return (
    <React.Fragment>
      <StyledAllGoals.StyledGoal
        outcomeColor={outcome.color}
        key={goal.id}
        className="flipped-goal-card"
      >
        <NoStyleButton
          type="button"
          onClick={() => showGoal(activeGoalId, setActiveGoalId)}
          disabled={!isVisible}
          aria-expanded={activeGoalId === goal.id}
          aria-controls={`goal-${goal.id}`}
        >
          <div className="lefter">
            <ProgressCircle
              fillColor={'transparent'}
              width={50}
              height={50}
              strokeWidth={4}
              strokeColor={lighten(outcome.color, 0.5)}
              percentComplete={'0'}
              progressStrokeColor={darken(outcome.color, 0.2)}
              className="goalCircle"
            >
              {renderGoalIcon()}
            </ProgressCircle>
            <StyledAllGoals.StyledGoalTitleCompletion>
              <h3> {goal.name} </h3>
              <p>
                {' '}
                {goal.steps.filter((c) => c.complete).length || 0}/
                {goal.steps.length} steps completed{' '}
              </p>
            </StyledAllGoals.StyledGoalTitleCompletion>
          </div>
          <StyledAllGoals.StyledOnlyHoverCarot outcomeColor={outcome.color} />
        </NoStyleButton>
      </StyledAllGoals.StyledGoal>
    </React.Fragment>
  );
};

Goal.propTypes = {
  outcome: object,
  outcomes: array,
  goal: shape({
    name: string,
    steps: array,
  }),
  isVisible: bool,
};

Goal.defaultProps = {
  goal: {
    steps: [],
  },
  isVisible: true
};

export default Goal;
